import { render } from "./NovedadesHrbp.vue?vue&type=template&id=7b8ccb48"
import script from "./NovedadesHrbp.vue?vue&type=script&lang=js"
export * from "./NovedadesHrbp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__